<template>
    <div class="opportunity-staged-moved-goal">
        <GoalModal
            data-qa="stage-moved-modal-goal"
            :is-open="isOpen"
            :goal-tip-link="$t('funnel.edit.goal.stageMove.url')"
            :goal-tip-text="$t('funnel.edit.goal.stageMove.proTip')"
            :summary-text="$t('funnel.edit.goal.stageMove.summary')"
            :title="$t('funnel.edit.goal.stageMove.title')"
            @close-modal="closeModal"
            @update-config="updateConfig"
        >
            <template #goalParameters>
                <DsMultiselect
                    v-model="selectedInOrOut"
                    :required="true"
                    data-qa="staged-moved-type-input"
                    bind-value-only
                    class="staged-moved-type-option"
                    :placeholder="$t('funnel.edit.goal.stageMove.moving')"
                    :options="inOrOutTypes"
                />
                <DsMultiselect
                    v-model="selectedStageId"
                    :required="true"
                    :force-invalid="validationErrorMessages !== null"
                    bind-value-only
                    class="staged-moved-type-id"
                    :placeholder="$t('funnel.edit.goal.stageMove.newStage')"
                    :options="stageOptions"
                >
                    <template #help>
                        <span v-if="validationErrorMessages !== null">
                            {{ validationErrorMessages }}
                        </span>
                    </template>
                </DsMultiselect>
            </template>
        </GoalModal>
    </div>
</template>

<script>
import GoalModal from '../goalModal/GoalModal.vue';
import { utils } from '../../../utils/legacy-utils';
import { loadStages } from './opportunity.stage.moved.api';

export const STAGED_MOVED_IDS = {
    in: 'IN',
    out: 'OUT',
};

export default {
    STAGED_MOVED_IDS,
    components: {
        GoalModal,
    },

    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                    inOrOut: null,
                    stageId: null,
                },
            }),
        },
    },

    emits: ['close-modal', 'update-cell-value'],

    data() {
        return {
            selectedInOrOut: this.cell?.value?.inOrOut ?? STAGED_MOVED_IDS.in,
            selectedStageId: this.cell?.value?.stageId,
            inOrOutTypes: [
                { value: STAGED_MOVED_IDS.in, label: this.$t('funnel.edit.goal.stageMove.in') },
                { value: STAGED_MOVED_IDS.out, label: this.$t('funnel.edit.goal.stageMove.out') },
            ],
            stageOptions: [],
            validationErrorMessages: null,
        };
    },

    async mounted() {
        await this.load();
    },

    methods: {
        async load() {
            try {
                await this.loadDropdowns();
                this.loadCellValue();
            } catch (error) {
                this.$error({ message: this.$t('funnel.edit.goal.stageMove.validation.loading') });
            }
        },
        async loadDropdowns() {
            this.stageOptions = await loadStages();
        },
        loadCellValue() {
            this.selectedInOrOut = this.cell?.value?.inOrOut ?? STAGED_MOVED_IDS.in;
            this.selectedStageId = Number(utils.removeLongSuffix(this.cell.value?.stageId));
        },

        closeModal() {
            this.$emit('close-modal');
        },

        isReady() {
            const valid = this.selectedStageId > 0;

            if (!valid) {
                this.validationErrorMessages = this.$t('funnel.edit.goal.stageMove.validation.empty');
            }

            return valid;
        },

        updateConfig() {
            if (this.isReady()) {
                this.saveConfig();
            }
        },

        saveConfig() {
            const cell = { ...this.cell };

            cell.value = cell.value || {};
            cell.value.inOrOut = this.selectedInOrOut;
            cell.value.stageId = this.selectedStageId;

            this.$emit('update-cell-value', { cell });
        },
    },
};
</script>


<style lang="scss">
.staged-moved-type .multiselect-single label {
    padding: 0;
}
.menu-item .option-subtext {
    font-size: $font-size-xs;
    color: $color-ink-800;
}

.menu-item.selected .option-subtext {
    color: $color-paper;
}

.opportunity-staged-moved-goal {
    div.modal-body {
        padding: 0;
    }
}
</style>
